export enum EFineTuningSettingNames {
	AERODYNAMIC_PROFILE = "AERODYNAMIC_PROFILE",
	CASTOR = "CASTOR",
	DOWNPIPE = "DOWNPIPE",
	FRONT_CAMBER = "FRONT_CAMBER",
	REAR_CAMBER = "REAR_CAMBER",
	FRONT_TOE = "FRONT_TOE",
	REAR_TOE = "REAR_TOE",
	CLEARANCE = "CLEARANCE",
	STEERING_LOCK = "STEERING_LOCK",
	SLIP_ANGLE = "SLIP_ANGLE",
	FRONT_TRACK_WIDTH = "FRONT_TRACK_WIDTH",
	REAR_TRACK_WIDTH = "REAR_TRACK_WIDTH",
}
